import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import StyledDatePicker from './StyledDatePicker'

interface DateTimeInputProps {
  placeholder: string
  type: 'start' | 'end'
}

const DateTimeInput: FC<DateTimeInputProps> = ({ placeholder, type }) => {
  const { control, watch } = useFormContext()

  const startDate = watch('startDate')
  const endDate = watch('endDate')

  const startDateObj = startDate ? new Date(startDate) : null
  const endDateObj = endDate ? new Date(endDate) : null

  const disabledDays = (() => {
    if (type === 'start' && endDateObj)
      return { after: endDateObj, before: new Date() }
    if (type === 'end' && startDateObj) return { before: startDateObj }
    return { before: new Date() }
  })()

  return (
    <Controller
      name={`${type}Date`}
      control={control}
      render={({ field }) => (
        <StyledDatePicker
          placeholder={placeholder}
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          noMargin
          type={type}
          //@ts-ignore
          disabledDays={disabledDays}
          data-test-id="date-input"
        />
      )}
    />
  )
}

export default DateTimeInput
